import clientApi from "@/shared/api/client"
import type { ApiResponse } from "@/shared/types/interface/api"
import type { HealthInfoDetail, HealthInfoListResponse } from "../model/types"
import { HEALTH_INFO_URL, HOSPITAL_HEALTH_INFO_PAGE_SIZE } from "./url"

const getHealthInfo = async <T>(url: string): Promise<ApiResponse<T>> => {
  const response = await clientApi.get<ApiResponse<T>>(url)
  if (response.status !== 200 || response.data.status !== 200) {
    throw new Error(response.data.message || "Health-info request failed")
  }
  return response.data
}

export const getHealthInfoListClient = (page = 1, size = 1000) =>
  getHealthInfo<HealthInfoListResponse>(HEALTH_INFO_URL.LIST(page, size))

export const getHospitalHealthInfoListClient = (
  hospitalOriginId: number,
  page = 1,
  size = HOSPITAL_HEALTH_INFO_PAGE_SIZE,
) => getHealthInfo<HealthInfoListResponse>(HEALTH_INFO_URL.HOSPITAL_LIST(hospitalOriginId, page, size))

export const getHealthInfoDetailClient = (id: number) =>
  getHealthInfo<HealthInfoDetail>(HEALTH_INFO_URL.DETAIL(id))
